<!-- 
Panel showing the levy calculation totals.
-->
<template>
  <our-data-container class="pt-3" right fluid>
    <our-data-field :label="totalLevyLabel" typography="display-2" label-width="3">
      {{ levyCalculation.totalLevy | currency }}
      <template v-slot:footer>
        <playground-up-down v-if="isLevyEstimator" field="totalLevy"/>
      </template>
    </our-data-field>
    <v-flex xs12/>
    <our-data-field typography="headline" label-width="3">
      <template slot="label">
        <span v-if="administrationFeeExempt">Administrative fee component</span>
        <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelAdministrativeFeeBreakdown)">Administrative fee component</a>
      </template>
      {{ levyCalculation.administrativeFeeComponent | currency }}
      <span v-if="administrationFeeWarning">
        <b>({{ administrationFeeWarning }})</b>
      </span>
      <template v-if="!administrationFeeExempt && !levyCalculation.capApplies">
        <calculation-percentage 
          :amount="levyCalculation.administrativeFeeComponent"
          :total="levyCalculation.totalLevyBeforeCap"
          :delay="100"
          color="#3182bd"
        />
      </template>
      <template v-slot:footer>
        <playground-up-down v-if="isLevyEstimator" field="administrativeFeeComponent"/>
      </template>
    </our-data-field>
    <our-data-field typography="headline" label-width="3">
      <template slot="label">
        <span v-if="riskRatingExempt">Risk rated premium component</span>
        <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelRiskRatedPremiumBreakdown)">Risk rated premium component</a>
      </template>
      {{ levyCalculation.riskRatedPremiumComponent | currency }}
      <span v-if="riskRatingWarning">
        <b>({{ riskRatingWarning }})</b>
      </span>
      <template v-if="!riskRatingExempt && !levyCalculation.capApplies">
        <calculation-percentage
          :amount="levyCalculation.riskRatedPremiumComponent"
          :total="levyCalculation.totalLevyBeforeCap"
          :previous-amount="levyCalculation.administrativeFeeComponent"
          :delay="700"
          color="#CC435F"
        />
      </template>
      <template v-slot:footer>
        <playground-up-down v-if="isLevyEstimator" field="riskRatedPremiumComponent"/>
      </template>
    </our-data-field>
    <our-data-field typography="headline" label-width="3">
      <template slot="label">
        <span v-if="specialTuitionProtectionExempt">Special tuition protection component</span>
        <a v-else class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelSpecialTuitionProtectionBreakdown)">Special tuition protection component</a>
      </template>
      {{ levyCalculation.specialTuitionProtectionComponent | currency }}
      <span v-if="specialTuitionProtectionWarning">
        <b>({{ specialTuitionProtectionWarning }})</b>
      </span>
      <template v-if="!specialTuitionProtectionExempt && !levyCalculation.capApplies">
        <calculation-percentage
          :amount="levyCalculation.specialTuitionProtectionComponent"
          :total="levyCalculation.totalLevyBeforeCap"
          :previous-amount="levyCalculation.administrativeFeeComponent + levyCalculation.riskRatedPremiumComponent"
          :delay="1000"
          color="#31a354"
        />
      </template>
      <template v-slot:footer>
        <playground-up-down v-if="isLevyEstimator" field="specialTuitionProtectionComponent"/>
      </template>
    </our-data-field>
    <our-data-field v-if="levyCalculation.capApplies" typography="headline" label-width="3">
      <template slot="label">
        <a class="i-link" href="#" @click.stop.prevent="$emit('click:openPanel', panelLevyCap)">Levy cap adjustment</a>
      </template>
      {{ levyCalculation.levyCapAdjustment | currency }}
      <template v-slot:footer>
        <playground-up-down v-if="isLevyEstimator" field="levyCapAdjustment"/>
      </template>
    </our-data-field>
  </our-data-container>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import CalculationPercentage from "@/components/levy-collection-providers/calculation/CalculationPercentage.vue";

export default {
  components: {
    PlaygroundUpDown,
    CalculationPercentage
  },
  mixins: [filterMixins, mixins],
  computed: {
    totalLevyLabel() {
      return this.isLevyEstimator ? "Total estimated levy" : "Total levy";
    }
  }
};
</script>
